export const TEST_ID = 'selectCalibrationKindField';
